export default {
  g_network_reachable: 'Reconnected to internet',
  g_network_unreachable: 'No internet connection',
}
